import React, { useCallback, useEffect, useState } from 'react';
import BaseDetails from 'containers/Base/BaseDetails.js';
import { translatedKeyValueText } from 'utils/methods/helpers';
import { getPersonName } from 'utils/details';
import staticText from 'static/text_display.json';
import { useDispatch, useSelector } from 'react-redux';
import { toggleConfirmPopup } from 'reducers/ui';
import { visitorActions, visitorPageActions } from '../';
import {
  getVisitorDetailsRaw,
  getVisitorDetailsTransformed,
} from '../Selectors/visitorSelectors';
import PropTypes from 'prop-types';
import styles from 'containers/Pages/Tasks/Emergencies/Layouts/index.module.scss';
import OperationalAction from 'components/Operational/operationalAction';
import { useTranslation } from 'react-i18next';
import isEmpty from 'lodash/isEmpty';
const VisitorDetails = ({ id, cancel, visitorStatus, downloadable }) => {
  const downloadButtonClick = () => {
    dispatchPrintVisitorDetails(id);
  };
  //------------------------------Selectors---------------------------------
  const details = useSelector(state => getVisitorDetailsTransformed(state));
  const rawDetails = useSelector(state => getVisitorDetailsRaw(state));
  //-----------------------Actions------------------------------------------
  const dispatch = useDispatch();
  const dispatchFetchVisitorDetails = useCallback(
    id => dispatch(visitorActions.fetchGridRowDetails({ id })),
    [dispatch],
  );
  const dispatchPrintVisitorDetails = useCallback(
    id => {
      dispatch(visitorPageActions.printVisitorDetails({ id }));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [dispatch],
  );
  const dispatchSignOutVisitor = useCallback(
    (id, details) => {
      dispatch(visitorPageActions.signOutVisitor({ id, details }));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [dispatch],
  );
  //sign out visitor stuff ---------------------------------------------
  const { t } = useTranslation();
  const [showLoginPopup, setLoginPopup] = useState();
  const handleSignOut = () => {
    dispatchSignOutVisitor(id, rawDetails);
    toggleLogoutPopup();
  };
  const toggleLogoutPopup = () => {
    setLoginPopup(!showLoginPopup);
  };
  const clickCancel = () => {
    cancel();
  };
  const buttonLogoutClick = () => {
    toggleLogoutPopup();
  };
  const operationalComponent = () => {
    return (
      <div className={styles.operationalAction}>
        <OperationalAction
          type="button"
          item={{
            btnText: staticText.operational_view.visitor.logout,
            btnClickHandler: buttonLogoutClick,
          }}
          confirmPopup={{
            showConfirmPopup: showLoginPopup,
            popupTitle: t(staticText.operational_view.visitor.logout),
            popupStatusMessage: '',
            popupActionMessage: !isEmpty(rawDetails)
              ? translatedKeyValueText('signout_confirmation', {
                  value: getPersonName(rawDetails.visitor),
                })
              : '',
            confirmBtnHandler: handleSignOut,
            confirmBtnText: t(staticText.general.ok),
            cancelBtnHandler: toggleLogoutPopup,
            cancelBtnText: t(staticText.general.cancel),
            closePopupHandler: toggleLogoutPopup,
          }}
        />
      </div>
    );
  };
  useEffect(() => {
    dispatchFetchVisitorDetails(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, dispatchFetchVisitorDetails]);
  console.log('details: ', details);

  return (
    <BaseDetails
      header={'Visitor Details'}
      details={details}
      cancel={clickCancel}
      editable={false}
      closeConfirmPopup={toggleConfirmPopup}
      downloadable={downloadable}
      operationComponent={!visitorStatus && operationalComponent()}
      onDownloadClick={downloadButtonClick}
      downloadHoverText={translatedKeyValueText('download_report_operational', {
        value: !isEmpty(rawDetails)
          ? getPersonName(rawDetails.visitor)
          : staticText.reporting_view.visitor_download,
      })}
    />
  );
};
VisitorDetails.propTypes = {
  id: PropTypes.string,
  cancel: PropTypes.func,
  visitorStatus: PropTypes.func,
  closeDetail: PropTypes.func,
  downloadable: PropTypes.bool,
};
export default VisitorDetails;
